import { Guarantees } from "../../../components/CommercialConditions/partials/ResumenConditions/partials/info/GuaranteeFields/GuaranteeFields";
import {
  DiscountType,
  PackagedBeerDetailsContainer,
  PointOfSaleMiniFragment,
  PointOfSaleSlide,
  ProductCategory,
  RecallType,
} from "../../../gql/hooks";

export const MAX_POS_NAME_LENGTH = 35;

// Step Types
export type ProposalInformationType = {
  name?: string;
  expireDay?: number;
  posId?: number;
  provinceNumber?: number;
  pos?: PointOfSaleMiniFragment;
  brandId?: number;
  typeOfVisit: ProposalTypeOfVisit;
  sherpaExternalId?: string;
};

export type ResumeFieldsType = {
  estimatedLiters: string;
  estimatedFreeLiters: string;

  // Discount & Bonus
  discount: string;
  rappel: string;
  noChargeProducts: string;

  // Loans
  loanImport: string;
  loanLiters: string;
  loanMonth: string;

  // Ads
  adsImport: string;
  adsLiters: string;
  adsMonth: string;

  // Apoyo
  marketingSupport: string;
  pointOfSaleSupport: string;
  plvSupport: string;
  specialDecoration: string;

  // Notes
  notes: string;
};

export type OperationContractType = {
  loanAmount: number;
  loanLiters: number;
  durationMonths: number;
  mortgageCoveredAmount: number;
  loanBankGuaranteeAmount: number;
  loanPersonalGuaranteeAmount: number;
  advertisingBankGuaranteeAmount: number;
  advertisingPersonalGuaranteeAmount: number;
};

export type ProductContractVolumes = {
  id: number;
  packagedProductId: number;
  productCode?: string | null;
  volume: number;
};

// Products Types
export type CommercialConditionType = {
  container?: PackagedBeerDetailsContainer;
  packagedProductId?: number;
  packagedProductUnitNb: string;
  freePackagedProductUnitsNb: string;
  discountValue?: string;
  discountType: DiscountType;
  discountX?: string;
  discountY?: string;
  recallValue?: string;
  recallType: RecallType;
  recallX?: string;
  recallY?: string;
  amortizationValue?: string;
  amortizationType: RecallType;
  amortizationX?: string;
  amortizationY?: string;
  price?: number;
  customPrice?: string;
  isTank?: boolean;
};

export type BeerProposalType = {
  id: string;
  order: number;
  productId: number;
} & CommercialConditionType;

export type MaterialCustomType = {
  name?: string;
  price?: string;
  unitsNb?: string;
};

export type MaterialProposalType = {
  id: string;
  order: number;
  productId?: number;
  packagedProductId?: number;
  packagedProductUnitNb?: string;
  price?: number;
  category?: ProductCategory;
  custom?: MaterialCustomType;
};

export type ProposalSlideType = PointOfSaleSlide & {
  imageId: number;
  isToggled: boolean;
  typeId?: number;
  isNew?: boolean;
  isMSC?: boolean;
  isNewCondition?: boolean;
};

export type ProposalSlidesType = {
  nameKey: string;
  type: string;
  change?: number;
  volumeFilter?: boolean;
  slides: ProposalSlideType[];
};

// Proposal Type Of Visit
export enum ProposalTypeOfVisit {
  Default = "Default",
  ClientAcquisition = "ClientAcquisition",
  BusinessDevelopment = "BusinessDevelopment",
  ClientDefense = "ClientDefense",
  Transfer = "Transfer",
}

// Sherpa New Products
export type SherpaNewPoductsType = {
  id: number;
  productPackageId?: number;
  container?: PackagedBeerDetailsContainer;
  isMSC?: boolean;
  isNewCondition?: boolean;
};

// Proposal Type
export interface ProposalReduxState {
  isOld?: boolean;
  currentStep: number;
  maxStep: number;

  proposalId?: number;
  proposalInformation: ProposalInformationType;

  products: BeerProposalType[];
  materials: MaterialProposalType[];

  ads?: any;
  guarantees?: Guarantees;
  resumeFields: ResumeFieldsType;

  isTankBilling: boolean;
  isDirectBilling: boolean;

  // Will be false when slides are generated
  // Will be true if any change is made
  isUpdated: boolean;
  isLoading: boolean;

  // Price Nets
  priceNetById?: {
    [key: string]: { value: number; volume: number };
  };

  // Slides
  slides: ProposalSlidesType[];
  slidesGeneration: {
    progress: number;
    isError: boolean;
  };

  // For Sherpa New Products
  newProducts: SherpaNewPoductsType[];
}
